export default "__VITE_ASSET__89aaecda__"